import './styles.scoped.css'
import {useEffect, useRef, useState} from 'react'
import {Box, Tabs, Tab, Paper, Typography, Avatar, Stack, Button} from '@mui/material'
import {ChevronRightRounded, DateRange, AccessTime} from '@mui/icons-material'
import {getColorFromName, getInitials, ignoreTimezone, parseError, formatTime} from '../../../../utils/helpers'
import {format} from 'date-fns'
import {useMobile} from '../../../../hooks'
import {dashboardApi} from '../../../../services'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {ConflictCardsSkeleton} from '../DashboardSkeletons'

export default () => {
    const {mobile} = useMobile()
    const {setMessageBox, branchId, dashboardDate, dashboardRefresh} = useGlobalStates()
    const [items, setItems] = useState(null)
    const [skeleton, setSkeleton] = useState(true)
    const requestId = useRef(0)

    const clients = [1, 2, 3]

    // A new day, branch or Refresh replaces the list with the skeleton.
    useEffect(() => {
        setSkeleton(true)
        setItems(null)
    }, [branchId, dashboardDate, dashboardRefresh])

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (branchId && dashboardDate) {
                const id = ++requestId.current
                dashboardApi
                    .getTodaysScheduleOverview(branchId, {date: format(dashboardDate, 'yyyy-MM-dd'), page_size: 100, tab: 'conflict'})
                    .then(
                        ({
                            data: {
                                data: {visits},
                            },
                        }) => {
                            if (id !== requestId.current) return
                            setItems(visits)
                            setSkeleton(false)
                        },
                    )
                    .catch(error => {
                        if (id !== requestId.current) return
                        const {title, description} = parseError(error)
                        if (description) {
                            setMessageBox({status: 'error', title, description})
                        }
                        setSkeleton(false)
                    })
            }
        }, 500)
        return () => clearTimeout(timeout)
    }, [branchId, dashboardDate, dashboardRefresh])

    return (
        <div className="container">
            {skeleton && <ConflictCardsSkeleton mobile={mobile} />}
            {items?.map((item, index) => (
                <div key={index}>
                    <br />
                    {mobile ? (
                        <div className="card">
                            <div className="datetime">
                                <div className="row-content">
                                    <Typography variant="body3" color="text.secondary">
                                        <DateRange fontSize="small" />
                                    </Typography>
                                    <Typography variant="body3" color="text.secondary">
                                        {format(new Date(ignoreTimezone(item?.date)), 'EEE, dd MMM yyyy')}
                                    </Typography>
                                </div>
                                <Typography variant="body3" color="text.secondary">
                                    |
                                </Typography>
                                <div className="row-content">
                                    <Typography variant="body3" color="text.secondary">
                                        <AccessTime fontSize="small" />
                                    </Typography>
                                    <Typography variant="body3" color="text.secondary">
                                        {formatTime(item?.start_time)} - {formatTime(item?.end_time)}
                                    </Typography>
                                </div>
                            </div>
                            <br />
                            <div className="people-card">
                                <Typography variant="caption" color="primary">
                                    CAREGIVER
                                </Typography>
                                {item?.caregiver?.avatar_url ? (
                                    <Avatar src={item?.caregiver?.avatar_url} style={{width: 40, height: 40}} />
                                ) : (
                                    <Avatar
                                        style={{
                                            backgroundColor: getColorFromName(item?.caregiver?.name),
                                            width: 40,
                                            height: 40,
                                            fontSize: 20,
                                        }}>
                                        {getInitials(item?.caregiver?.name)}
                                    </Avatar>
                                )}
                                <div className="people-profile-card">
                                    <Typography variant="h8" color="text.primary" className="name">
                                        {item?.caregiver?.name}
                                    </Typography>
                                    <Typography variant="body3" color="text.secondary" className="name">
                                        {item?.caregiver?.email}
                                    </Typography>
                                </div>
                            </div>
                            <br />
                            <Typography variant="h8" color="error">
                                6 schedules conflict
                            </Typography>
                            <br />
                            {clients.map((client, index) => (
                                <div key={index}>
                                    <br />
                                    <div className="client-card">
                                        <Typography variant="caption" color="primary">
                                            CLIENT
                                        </Typography>
                                        <div className="people-card">
                                            {client?.avatar_url ? (
                                                <Avatar src={client?.avatar_url} style={{width: 40, height: 40}} />
                                            ) : (
                                                <Avatar
                                                    style={{
                                                        backgroundColor: getColorFromName(client?.first_name + ' ' + client?.last_name),
                                                        width: 40,
                                                        height: 40,
                                                        fontSize: 20,
                                                    }}>
                                                    {getInitials(client?.first_name + ' ' + client?.last_name)}
                                                </Avatar>
                                            )}
                                            <div className="people-profile-card">
                                                <Typography variant="h8" color="text.primary" className="name">
                                                    Melisa Adam
                                                </Typography>
                                                <Typography variant="body3" color="text.secondary" className="name">
                                                    melisa@gmail.com
                                                </Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <br />
                            <Typography variant="body1" color="text.primary">
                                +3 more
                            </Typography>
                        </div>
                    ) : (
                        <div className="card">
                            <div className="card-top">
                                <div className="card-top-left">
                                    <div className="datetime">
                                        <div className="row-content">
                                            <Typography variant="body3" color="text.secondary">
                                                <DateRange fontSize="small" />
                                            </Typography>
                                            <Typography variant="body3" color="text.secondary">
                                                {format(new Date(ignoreTimezone(item?.date)), 'EEE, dd MMM yyyy')}
                                            </Typography>
                                        </div>
                                        <Typography variant="body3" color="text.secondary">
                                            |
                                        </Typography>
                                        <div className="row-content">
                                            <Typography variant="body3" color="text.secondary">
                                                <AccessTime fontSize="small" />
                                            </Typography>
                                            <Typography variant="body3" color="text.secondary">
                                                {formatTime(item?.start_time)} - {formatTime(item?.end_time)}
                                            </Typography>
                                        </div>
                                    </div>
                                    <Typography variant="caption" color="primary">
                                        CAREGIVER
                                    </Typography>
                                    <div className="people-card">
                                        {item?.caregiver?.avatar_url ? (
                                            <Avatar src={item?.caregiver?.avatar_url} style={{width: 40, height: 40}} />
                                        ) : (
                                            <Avatar
                                                style={{
                                                    backgroundColor: getColorFromName(item?.caregiver?.name),
                                                    width: 40,
                                                    height: 40,
                                                    fontSize: 20,
                                                }}>
                                                {getInitials(item?.caregiver?.name)}
                                            </Avatar>
                                        )}
                                        <div className="people-profile-card">
                                            <Typography variant="h8" color="text.primary" className="name">
                                                {item?.caregiver?.name}
                                            </Typography>
                                            <Typography variant="body3" color="text.secondary" className="name">
                                                {item?.caregiver?.email}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                                <Typography variant="h8" color="error">
                                    6 schedules conflict
                                </Typography>
                            </div>
                            <br />
                            <div className="card-bottom">
                                {clients.map((client, index) => (
                                    <div className="client-card" key={index}>
                                        <Typography variant="caption" color="primary">
                                            CLIENT
                                        </Typography>
                                        <div className="people-card">
                                            {client?.avatar_url ? (
                                                <Avatar src={client?.avatar_url} style={{width: 40, height: 40}} />
                                            ) : (
                                                <Avatar
                                                    style={{
                                                        backgroundColor: getColorFromName(client?.first_name + ' ' + client?.last_name),
                                                        width: 40,
                                                        height: 40,
                                                        fontSize: 20,
                                                    }}>
                                                    {getInitials(client?.first_name + ' ' + client?.last_name)}
                                                </Avatar>
                                            )}
                                            <div className="people-profile-card">
                                                <Typography variant="h8" color="text.primary" className="name">
                                                    Melisa Adam
                                                </Typography>
                                                <Typography variant="body3" color="text.secondary" className="name">
                                                    melisa@gmail.com
                                                </Typography>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <Typography variant="body1" color="text.primary">
                                    +3 more
                                </Typography>
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}
